// extracted by mini-css-extract-plugin
export var completionBody = "_i5-2";
export var completionCard = "_i5-0";
export var completionFooter = "_i5-3";
export var completionTitle = "_i5-1";